import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import Logo2Blue from '../../assets/logo2_blue.png';
import SignUpFormIncentive from '../SignUpFormIncentive';

import {
  SignupFormContainer,
  ModalLogo,
  ModalCloseIcon,
  ReturnToSiteText,
  ReturnToSiteLink,
} from './SignUpModalIncentive.styles';

export const SignUpModalIncentive = (props) => {
  return (
    <SignupFormContainer>
      <ModalCloseIcon
        onClick={props.closeModal}
        buttonName="x-close"
      >
        <FaTimes />
      </ModalCloseIcon>
      <ModalLogo src={Logo2Blue} alt="Starguide Logo - Free Horoscopes for Life and Love" />
      <SignUpFormIncentive
        closeModal={props.closeModal}
      />
      <ReturnToSiteText>
        Not interested?
        <ReturnToSiteLink
          onClick={props.closeModal}
          buttonName="not-interested-text"
        >
          Click here to return to the site
        </ReturnToSiteLink>
      </ReturnToSiteText>
    </SignupFormContainer>
  );
};

SignUpModalIncentive.propTypes = {
  closeModal: PropTypes.func,
};

export default SignUpModalIncentive;
